module.exports = require("@amzn/ceramic-jsx");